export const namespace = 'https://www.dermatopathologyconsultations.com';
